var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconClipboard = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.647368 0H1.521053C.684474 0 0 .695455 0 1.545455v10.818181h1.521053V1.545455h9.126315V0zm2.281579 3.09091H4.563158c-.836579 0-1.521053.695454-1.521053 1.545454v10.818182c0 .85.684474 1.545454 1.521053 1.545454h8.365789c.836579 0 1.521053-.695454 1.521053-1.545454V4.636364c0-.85-.684474-1.545455-1.521053-1.545455zm0 12.363636H4.563158V4.636364h8.365789v10.818182z",
    fill: "#BEC8D2",
    fillRule: "nonzero"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClipboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-clipboard.c53f2936.svg";
export { ForwardRef as ReactComponent };